import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_EXAM_ROOMS, 
    ADD_NEW_EXAM_ROOM, 
    UPDATE_EXAM_ROOM, 
    DELETE_EXAM_ROOM,
    CHECK_EXAM_ROOM_AVAILABILITY,
} from "./actionTypes";

import {
    getExamRoomsSuccess,
    getExamRoomsFail,
    addExamRoomSuccess,
    addExamRoomFail,
    updateExamRoomSuccess,
    updateExamRoomFail,
    deleteExamRoomSuccess,
    deleteExamRoomFail,
    checkExamRoomAvailabilitySuccess, 
    checkExamRoomAvailabilityFail,
   
} from "./actions"

import {
    getExamRooms,
    addNewExamRoom,
    updateExamRoom,
    deleteExamRoom,
    checkExamRoomAvailability,
   
} from "helpers/exam-rooms/exam_rooms_backend_helper";
import { toast } from "react-toastify";

function* fetchExamRooms() {
    try {
        const response = yield call(getExamRooms)

        console.log("EXAM ROOMS: ", response.examRooms);
        yield put(getExamRoomsSuccess(response.examRooms))
    } catch (error) {
        yield put(getExamRoomsFail(error))
    }
}

function* onAddNewExamRoom({ payload }) {
    try {

        
        const response = yield call(addNewExamRoom, payload)

        console.log("RESPONSE:", response);
        yield put(addExamRoomSuccess(response.examRoom))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addExamRoomFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateExamRoom({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateExamRoom, payload)
        yield put(updateExamRoomSuccess(response.examRoom))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateExamRoomFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteExamRoom({ payload: data }) {

    try {
        const response = yield call(deleteExamRoom, data)
        yield put(deleteExamRoomSuccess(response.examRoomId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteExamRoomFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

// ─── Disponibilité ────────────────────────────────────────────────────────────

function* checkExamRoomAvailabilitySaga({ payload }) {
    try {
        const response = yield call(checkExamRoomAvailability, payload);
        yield put(checkExamRoomAvailabilitySuccess(response));
    } catch (error) {
        yield put(checkExamRoomAvailabilityFail(error));
    }
}


function* examRoomSaga() {
    yield takeEvery(GET_EXAM_ROOMS, fetchExamRooms)
    yield takeEvery(ADD_NEW_EXAM_ROOM, onAddNewExamRoom)
    yield takeEvery(UPDATE_EXAM_ROOM, onUpdateExamRoom)
    yield takeEvery(DELETE_EXAM_ROOM, onDeleteExamRoom)
    yield takeEvery(CHECK_EXAM_ROOM_AVAILABILITY, checkExamRoomAvailabilitySaga);
}

export default examRoomSaga;